import React, { useState } from 'react';
import { Card, Form, Switch, Typography } from 'antd';

export interface AreaHierarchyConfig {
    showMap: boolean;
}

const DEFAULT_AREA_HIERARCHY_CONFIG: AreaHierarchyConfig = {
    showMap: true,
};

interface Props {
    initialConfig?: Partial<AreaHierarchyConfig>;
    onChange: (config: AreaHierarchyConfig) => void;
}

export const SectionConfigAreaHierarchy: React.FC<Props> = ({ initialConfig, onChange }) => {
    const [config, setConfig] = useState<AreaHierarchyConfig>({
        ...DEFAULT_AREA_HIERARCHY_CONFIG,
        ...initialConfig,
    });

    const updateField = (field: keyof AreaHierarchyConfig, value: any) => {
        const newConfig = { ...config, [field]: value };
        setConfig(newConfig);
        onChange(newConfig);  // Call onChange directly to avoid infinite loop
    };

    return (
        <Card size="small" style={{ background: '#f5f5f5' }}>
            <Typography.Text strong style={{ display: 'block', marginTop: 16, marginBottom: 12 }}>
                Display Settings
            </Typography.Text>
            <Form.Item label="Show map view" help="Display the map visualization alongside the hierarchy table">
                <Switch
                    checked={config.showMap}
                    onChange={(checked) => updateField('showMap', checked)}
                />
            </Form.Item>
            <Typography.Paragraph type="secondary" style={{ fontSize: 12, marginTop: 16 }}>
                This visual type displays a read-only hierarchical view of the selected area and all its children,
                similar to the Areas page. The map shows all areas with proper rendering using area type templates
                when available. This is useful for providing context about area structure in reports.
            </Typography.Paragraph>
        </Card>
    );
};

export default SectionConfigAreaHierarchy;

